module.exports = __webpack_public_path__ + "static/media/g-logo.301c9a74.png";